import { createStore } from 'owa-satcheljs';

export interface DevicePermissionsDialogState {
    isOpen: boolean;
    appId: string;
    tabId?: string;
}

export const devicePermissionsStore: () => DevicePermissionsDialogState =
    createStore<DevicePermissionsDialogState>('devicePermissionsDialogStore', {
        isOpen: false,
        appId: '',
        tabId: undefined,
    });
